<template>
  <div class="py-4">
    <template v-if="useDirectProps">
      <div v-if="!loading && (!dishes || dishes.length === 0)">
        <SectionEmptyState
          :title="
            type === 'near'
              ? 'Rien près de chez vous ?'
              : 'Pas de recommandations actuellement'
          "
          :description="
            type === 'near'
              ? 'Les restaurants arrivront bientôt dans votre zone !'
              : 'Nos recommandations pour vous arrivent bientôt.'
          "
          :icon-type="type === 'near' ? 'near' : 'recommendations'"
          @refresh="$emit('refresh')"
        />
      </div>
      <div v-else class="overflow-auto w-full pb-12 -mb-12 px-6">
        <div class="flex gap-4 min-w-max">
          <div
            v-for="(item, i) in loading
              ? [{ shimmer: true }, { shimmer: true }, { shimmer: true }]
              : dishes || []"
            class="w-[70vw]"
            :key="i"
          >
            <component :is="dishItemComponent" :item="item" />
          </div>
        </div>
      </div>
    </template>

    <DataFetcher
      v-else
      dataKey="dishes"
      :emptyChecker="(data) => !Array.isArray(data) || data.length == 0"
      :filters="{ lng: '', lat: '' }"
    >
      <template #empty="{ refresh }">
        <SectionEmptyState
          :title="
            type === 'near' ? 'Rien près de chez vous ?' : 'Bientôt disponible'
          "
          :description="
            type === 'near'
              ? 'Nous arrivons bientôt dans votre zone !'
              : 'Nos recommandations arrivent bientôt.'
          "
          :icon-type="type === 'near' ? 'near' : 'recommendations'"
          @refresh="refresh"
        />
      </template>

      <template
        #default="{ refresh, loading, loadingError, data: fetchedDishes }"
      >
        <div class="overflow-auto w-full pb-12 -mb-12 px-6">
          <div class="flex gap-4 min-w-max">
            <div
              v-for="(item, i) in loading
                ? [{ shimmer: true }, { shimmer: true }, { shimmer: true }]
                : fetchedDishes || []"
              class="w-[70vw]"
              :key="i"
            >
              <component :is="dishItemComponent" :item="item" />
            </div>
          </div>
        </div>
      </template>
    </DataFetcher>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import DishCard from './DishCard.vue';
import NearDishCard from './NearDishCard.vue';

export default defineComponent({
  name: 'DishesListHz',
  components: { DishCard, NearDishCard },
  props: {
    type: {
      type: String,
      default: ''
    },
    dishes: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    useDirectProps() {
      return this.dishes !== null;
    },
    dishItemComponent() {
      if (this.type == 'near') return 'NearDishCard';
      return 'DishCard';
    }
  }
});
</script>

<style scoped>
/* Horizontal scroll container styles */
</style>
